import { useAuth0 } from "@auth0/auth0-react";
import {
  Avatar,
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
  Typography,
} from "@mui/material";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import LanguageSelector from "./Forms/LanguageSelector";

// Account menu (identity, language selector, logout) anchored to the top-bar avatar.
export default function UserMenu({ anchorEl, onClose }) {
  const { user, logout: auth0Logout } = useAuth0();

  const logout = () => {
    onClose();
    auth0Logout({
      logoutParams: { returnTo: window.location.origin + "/login" },
    });
  };

  if (!user) return null;

  return (
    <Popover
      id="user-menu"
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      // The language list is a separate popper; don't let this popover steal its focus.
      disableEnforceFocus
      slotProps={{ paper: { sx: { width: 300, mt: 0.5, borderRadius: "12px" } } }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, p: 2 }}>
        <Avatar src={user.picture} alt={user.nickname || ""} sx={{ width: 44, height: 44 }} />
        <Box sx={{ minWidth: 0 }}>
          <Typography noWrap fontWeight={600}>
            {user.nickname}
          </Typography>
          <Typography noWrap variant="body2" color="text.secondary">
            {user.email}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box sx={{ px: 1, py: 0.5 }}>
        <LanguageSelector />
      </Box>
      <Divider />
      <MenuItem onClick={logout} sx={{ py: 1.25 }}>
        <ListItemIcon>
          <LogoutRoundedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Log out" />
      </MenuItem>
    </Popover>
  );
}
